import React from "react";
import { View, Pressable, StyleSheet } from "react-native";
import { useAppConfig } from "../../../../AppConfigProvider";

const SelectableList = ({
  items,
  onSelect,
  selectedItem,
  selectItemStyle = {},
  selectedItemStyle = {},
  fullWidth = false,
  ariaLabel = "group of radio buttons",
}) => {
  const { primaryColor } = useAppConfig();

  const handleSelect = (item) => {
    onSelect(item);
  };

  const containerStyle = fullWidth ? styles.fullWidthContainer : styles.container;
  const itemStyle = fullWidth ? styles.fullWidthItem : styles.item;

  return (
    <View style={containerStyle} role="radiogroup" aria-label={ariaLabel}>
      {items.map((item, index) => (
        <Pressable
          key={index}
          style={[
            itemStyle,
            selectItemStyle,
            selectedItem === item.value && {
              ...styles.selectedItem,
              borderColor: primaryColor,
              ...selectedItemStyle,
            },
          ]}
          onPress={() => handleSelect(item.value)}
          role="radio">
          {item.component}
        </Pressable>
      ))}
    </View>
  );
};

export default SelectableList;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingVertical: 10,
  },
  fullWidthContainer: {
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "stretch",
    paddingVertical: 10,
  },
  item: {
    borderWidth: 2,
    borderColor: "transparent",
    borderRadius: 10,
    marginHorizontal: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  fullWidthItem: {
    borderWidth: 2,
    borderColor: "transparent",
    borderRadius: 10,
    marginHorizontal: 0,
    marginVertical: 4,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  selectedItem: {
    borderWidth: 2,
  },
});
